import styled from 'styled-components';

export const ErrorMessage = styled.div`
color: #dd1818;

`

export const SuccessMessage = styled.div`
color: #1b945c;

`